import Component from '../Component';

export default class WindowEvents extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {

    this.onResize();
    this.onOrientationChange();
    this.onScroll();

  }

  onResize() {

    let resizeEnd;

    window.addEventListener('resize', () => {
      clearTimeout(resizeEnd);
      resizeEnd = setTimeout(() => {

        this.logger('Window resized');

        this.App.Events.publish('window.resize', {
          width:  document.documentElement.clientWidth,
          height: document.documentElement.clientHeight
        });

      }, 100);

    });
  }

  onOrientationChange() {

    let orientationChangeEnd;
    window.addEventListener('orientationchange', () => {
      clearTimeout(orientationChangeEnd);
      orientationChangeEnd = setTimeout(() => {
        this.logger('Window orientation changed');
        this.App.Events.publish('window.orientationchange', true);
      }, 100);
    });

  }

  onScroll() {

    window.addEventListener('scroll' , () => {

      let offset = window.scrollY || window.scrollTop || document.getElementsByTagName('html')[0].scrollTop;;

      this.App.Events.publish(
        'window.scroll',
        offset
      );
    });

  }

}